import {
  DestroyRef,
  ProviderToken,
  ChangeDetectorRef,
  Component,
  inject,
  Injector,
  input,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import type { FormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import type { Observable } from 'rxjs';

import type { SelectGroupedOptions } from '@core/user-interface-legacy';
import { SelectComponent } from '@core/user-interface-legacy';

import { DepartmentSelectOptionsFacade } from './data/department-select-options.facade';
import type {
  DynamicSelectFieldType,
  DynamicSelectOptionsProvider,
} from './dynamic-select-field.types';

// TODO: We should extract this from requisitions. It should probably be split into separate and independent select fields:
// DepartmentSelect (move to Department lib), CurrencySelect (move to Currency lib) etc.

const injectorMap: Record<DynamicSelectFieldType, ProviderToken<DynamicSelectOptionsProvider>> = {
  department: DepartmentSelectOptionsFacade,
};

@Component({
  selector: 'rt-requisitions-dynamic-select-field',
  template: `
    <rt-select
      [formControl]="form()"
      [hasInputTrigger]="true"
      [searchPlaceholder]="searchPlaceholder()"
      [groupedOptions]="selectGroupedOptions"
      [hasClearButton]="hasClearButton()"
      [disabled]="isDisabled()"
      [readOnly]="isReadOnly()"
      [placeholder]="placeholder()"
      [isInvalid]="isInvalid()"
    />
  `,
  imports: [SelectComponent, ReactiveFormsModule],
  providers: [DepartmentSelectOptionsFacade],
})
export class DynamicSelectFieldComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly injector = inject(Injector);

  protected readonly cdRef = inject(ChangeDetectorRef);

  public readonly type = input<DynamicSelectFieldType>(undefined!);
  public readonly form = input<FormControl>(undefined!);
  public readonly searchPlaceholder = input<string>(undefined!);
  public readonly placeholder = input<string>(undefined!);
  public readonly isDisabled = input<boolean>(false);
  public readonly isReadOnly = input<boolean>(false);
  public readonly hasClearButton = input<boolean>(false);
  public readonly isInvalid = input<boolean>(false);

  public selectGroupedOptions$: Observable<SelectGroupedOptions[]>;
  public selectGroupedOptions: SelectGroupedOptions[] = [];

  public ngOnInit(): void {
    this.selectGroupedOptions$ = this.injector.get(injectorMap[this.type()]).selectGroupedOptions$;

    this.selectGroupedOptions$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(options => {
      this.selectGroupedOptions = options;
      this.cdRef.detectChanges();
    });
  }
}
